import Device from 'src/devices/device';
import { getDataOfConfigSteamsTypes, consoleLog } from './utilsStreamTypesConfig';
import { toUTF8 } from 'src/utils/Utils';

const addServerCertificate = () => {
  const devicePlatform = Device.getDevice().getPlatform();

  const isTizen = devicePlatform === 'tizen';
  const isHisense = devicePlatform === 'hisense';
  const userAgent = navigator.userAgent.toLowerCase();

  const isTizen3_0 = isTizen && userAgent.indexOf('tizen 3.0') > -1; // 2017
  const isHisenseVidaa53 = isHisense && userAgent.indexOf('chrome/53') !== -1// 2018 Vidaa 2.5

  return isTizen ? isTizen3_0 : isHisenseVidaa53;
}

export const getConfigDashWV = (options) => {
    console.log('=> PAU LOADMEDIA ES DASHWV');

    const { src, poster, server_url, device_id, certificate_url, cert } = getDataOfConfigSteamsTypes(options);

    let challenge = null;
    let _header = null;
    let widevineConfig = null;

    const addCertificate = addServerCertificate();

    if (options.drmInfo && options.drmInfo.challenge) {
        const _challenge = (options.drmInfo && options.drmInfo.challenge) || '';
        if (_challenge && _challenge.indexOf('tokenID') !== -1) {
            challenge = _challenge;
            _header = {
                'Dt-Custom-Data': btoa(_challenge),
            };
            widevineConfig = {
              widevine: {
                LA_URL: server_url,
                certificateURL: certificate_url,
                headers: _header,
                utf8message: true,
                plaintextChallenge: true,
              }
            };

            if(!addCertificate) {
              widevineConfig.widevine.serverCertificate = cert;
            }
        } else {
            challenge = JSON.parse(_challenge);
            challenge = challenge.token;

            const _token = { token: challenge, device_id: device_id };
            console.log('=> PAU _token para header licenser: ', _token);
            widevineConfig = {
              // widevine: {
              //   LA_URL: server_url,
              //   certificateURL: certificate_url,
              //   serverCertificate: cert,
              //   headers: _header,
              //   utf8message: true,
              //   plaintextChallenge: true,
              // }

              // LO DE ABAJO ES PLAY CON BODY MESSAGE Y SA SÍ JALA CON AMCO Y PICARDIA PERO CON HBO NO
              // POR ESO MEJOR SE RECOMIENDA HBO CON HEADER + DASHWV COMO ESTA ARRIBA PORQUE AL MENOS ASI
              // SÍ REPRODUCE EN WEB0S
              widevine: {
                'LA_URL': server_url,
                utf8message: true,
                videoRobustness: 'SW_SECURE_CRYPTO',
                audioRobustness: 'SW_SECURE_CRYPTO',
                certificateURL: certificate_url,
                prepareMessage: keyMessage =>
                  new Uint8Array(
                    toUTF8(
                      JSON.stringify({
                        token: challenge,
                        device_id: device_id,
                        widevineBody: btoa(
                          String.fromCharCode.apply(
                            null,
                            new Uint8Array(keyMessage.message),
                          )
                        )
                      })
                    )
                  ).buffer,
              }
            }

            if(!addCertificate) {
              widevineConfig.widevine.serverCertificate = cert;
            }
        }
    }

    consoleLog('=> PAU server_url ' + server_url);
    consoleLog('=> PAU certificate_url' + certificate_url);
    consoleLog('=> PAU video_url' + src);
    consoleLog('=> PAU _challenge' + challenge);
    console.log('=> PAU device_id', device_id);

    const config = {
        title: '',
        description: '',
        poster,
        dash: src,
        drm: widevineConfig ? widevineConfig : {},
    };

    return config;
};



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/streams-types-config/dashWideVine.js